import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ReplaceUndefinedWithNullInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const cleanedBody = this.replaceUndefinedWithNull(req.body);

        const modifiedReq = req.clone({
            body: cleanedBody
        });

        return next.handle(modifiedReq);
    }

    private replaceUndefinedWithNull(value: any): any {
        if (value === undefined) {
            return null;
        }

        if (value === null || typeof value !== 'object') {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map((v) => this.replaceUndefinedWithNull(v));
        }

        const result: any = {};
        for (const key of Object.keys(value)) {
            result[key] = this.replaceUndefinedWithNull(value[key]);
        }

        return result;
    }
}
